export enum VerificationStatus {
  READY = 'READY',
  VERIFIED_PHONE = 'VERIFIED_PHONE',
  VERIFIED_PASSPORT = 'VERIFIED_PASSPORT',
}
